export default __webpack_public_path__ + "static/media/sql.4cec57ec.svg";